import { createSelector } from '@reduxjs/toolkit';

import { isValidSelector } from 'src/store/touristsValidation/selectors';
import { name } from '../reducers/validation';
import type { ValidationStateType } from '../validation/types';

const getValidationErrorsState = (state): ValidationStateType => state[name];

export const getValidarionErrors = createSelector(
  getValidationErrorsState,
  (errors) =>
    errors.reduce((result, current) => {
      result[current.path.split('.')[1]] = current.message;
      return result;
    }, {}),
);

export const getValidationError = createSelector(
  [getValidationErrorsState, isValidSelector],
  (errors, isValid) => errors.length !== 0 || !isValid,
);

const _getTouristErrors = createSelector(
  [getValidationErrorsState, (_: ValidationStateType, idx: number) => idx],
  (errors, idx) => errors.filter((error) => error.path.startsWith(`[${idx}]`)),
);

export const makeGetTouristErrors = () =>
  createSelector(
    (state: ValidationStateType, idx: number) => _getTouristErrors(state, idx),
    (errors) =>
      errors.reduce((result, current) => {
        result[current.path.split('.')[1]] = current.message;
        return result;
      }, {}),
  );

export const getFirstTouristError = createSelector(
  _getTouristErrors,
  (errors) => errors?.[0] || null,
);

// TODO: THINK ABOUT IT
// const _getFieldErrorz = (state, props) => _getTouristErrors(state, props)
// .filter(error => error.path.split('.')[1] === props.stateField);
// export const makeGetFieldError = () => createSelector(
//   [_getFieldErrorz],
//   (errors) => {
//     const [error] = errors.toJS();
//     return error ? error.message : null;
//   },
// );
